import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _CaskDeskAccount } from "../../../../core/services/dataBean/EntityCatalog";

interface Props {
    idSelector: number;
    onChange: Function;
    city: number;
    label?: string;
    idAccount?: number;
}

export const SelectInboxCash = ({ city, idSelector, onChange, label, idAccount }: Props) => {

    const { instance, lista, setLista } = useDataBean(_CaskDeskAccount)
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        if (city) {
            getLista();
        }
        setLista([]);
    }, [city])

    const setValue = (e: any) => {
        setID(e);

        if (e == "") {
            onChange(null)
        } else {
            onChange(e);
        }
    }

    
    const getLista = () => {
        instance.getCashDeskAccountCatalog(city, idAccount ?? null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }

    return (
        <>
            <label>{label ?? "Caja Menor"}</label>
            <select className="form-select" value={id} onChange={(e) => setValue(e.target.value)}>
                <option value={""}>....</option>
                {lista.map((item: any, index: number) => {
                    return (
                        <option key={index} value={item.DataBeanProperties.IDCashDeskAccount}>{item.DataBeanProperties.IDCashDeskAccount} - {item.DataBeanProperties.Name} - {item.DataBeanProperties.AccountName}</option>
                    )
                })}
            </select>
        </>
    )
}